module.exports = __webpack_public_path__ + "img/check-error.f471b806.svg";